import { render, staticRenderFns } from "./AgDetailInformation.vue?vue&type=template&id=1f117a5d&scoped=true"
import script from "./AgDetailInformation.vue?vue&type=script&lang=js"
export * from "./AgDetailInformation.vue?vue&type=script&lang=js"
import style0 from "./AgDetailInformation.vue?vue&type=style&index=0&id=1f117a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f117a5d",
  null
  
)

export default component.exports